export default {
	name: 'school-affair',
	path: '/school-affair',
	meta: {
		title: '校务中心'
	},
	redirect: '/school-affair/notice',
	children: [
		{
			name: 'affair-notice',
			path: 'notice',
			meta: {
				title: '通知公告',
				icon: 'icon-home'
			},
			redirect: '/school-affair/notice/template',
			component: () =>
				import(/* webpackChunkName: "school-affair" */ '@/views/school-affair/notice'),
			children: [
				{
					name: 'notice-template',
					path: 'template',
					fullPath: '/school-affair/notice/template',
					meta: {
						title: '通知模板'
					},
					component: () =>
						import(/* webpackChunkName: "school-affair" */ '@/views/school-affair/notice/template')
				},
				{
					name: 'notice-template-edit',
					path: 'edit',
					fullPath: '/school-affair/notice/notice-template-edit',
					meta: {
						// title: '添加模板'
					},
					component: () =>
						import(/* webpackChunkName: "school-affair" */ '@/views/school-affair/notice/template/edit')
				},
				{
					name: 'notice-record',
					path: 'record',
					fullPath: '/school-affair/notice/record',
					meta: {
						// title: '接收记录'
					},
					component: () =>
						import(/* webpackChunkName: "school-affair" */ '@/views/school-affair/notice/record')
				},
				{
					name: 'notice-announce',
					path: 'announce',
					fullPath: '/school-affair/notice/announce',
					meta: {
						// title: '通知发布'
					},
					component: () =>
						import(/* webpackChunkName: "school-affair" */ '@/views/school-affair/notice/announce')
				},
				{
					name: 'notice-rule',
					path: 'rule',
					fullPath: '/school-affair/notice/rule',
					meta: {
						// title: '规则设置'
					},
					component: () =>
						import(/* webpackChunkName: "school-affair" */ '@/views/school-affair/notice/rule')
				},
				{
					name: 'notice-anomaly',
					path: 'anomaly',
					fullPath: '/school-affair/notice/anomaly',
					meta: {
						// title: '异常列表'
					},
					component: () =>
						import(/* webpackChunkName: "school-affair" */ '@/views/school-affair/notice/anomaly')
				},
				{
					name: 'releasing-notices',
					path: '/releasing-notices',
					meta: {
						title: '通知发布'
					},
					component: () =>
						import(/* webpackChunkName: "school-affair" */ '@/views/school-affair/notice/releasing-notices')
				}
			]
		},
		{
			name: 'affair-myschool',
			path: 'myschool',
			fullPath: '/school-affair/myschool',
			meta: {
				title: '我的学校',
				icon: 'icon-home'
			},
			redirect: '/school-affair/myschool/intro',
			component: () =>
				import(/* webpackChunkName: "school-affair" */ '@/views/school-affair/myschool'),
			children: [
				{
					name: 'myschool-intro',
					path: 'intro',
					fullPath: '/school-affair/myschool/intro',
					meta: {
						title: '学校简介'
					},
					redirect: '/school-affair/myschool/intro/site',
					component: () =>
						import(/* webpackChunkName: "school-affair" */ '@/views/school-affair/myschool/intro'),
					children: [
						{
							name: 'intro-site',
							path: 'site',
							fullPath: '/school-affair/myschool/intro/site',
							meta: {
								// title: '标记地理位置'
							},
							component: () =>
								import(/* webpackChunkName: "school-affair" */ '@/views/school-affair/myschool/intro/site')
						},
						{
							name: 'intro-edit-profile',
							path: 'edit-profile',
							fullPath: '/school-affair/myschool/intro/edit-profile',
							meta: {
								// title: '编辑学校简介'
							},
							component: () =>
								import(/* webpackChunkName: "school-affair" */ '@/views/school-affair/myschool/intro/edit-profile')
						}
					]
				},
				{
					name: 'myschool-news',
					path: 'news',
					fullPath: '/school-affair/myschool/news',
					meta: {
						title: '学校新闻'
					},
					redirect: '/school-affair/myschool/news/news-release',
					component: () =>
						import(/* webpackChunkName: "school-affair" */ '@/views/school-affair/myschool/news'),
					children: [
						{
							name: 'news-news-release',
							path: 'news-release',
							fullPath: '/school-affair/myschool/news/news-release',
							meta: {
								// title: '新闻发布'
							},
							component: () =>
								import(/* webpackChunkName: "school-affair" */ '@/views/school-affair/myschool/news/news-release')
						},
						{
							name: 'news-news-list',
							path: 'news-list',
							fullPath: '/school-affair/myschool/news/news-list',
							meta: {
								// title: '新闻列表'
							},
							component: () =>
								import(/* webpackChunkName: "school-affair" */ '@/views/school-affair/myschool/news/news-list')
						}
					]
				}
			]
		},
		{
			name: 'affair-homework',
			path: 'homework',
			meta: {
				title: '作业',
				icon: 'icon-home'
			},
			redirect: '/school-affair/homework/work-list',
			component: () =>
				import(/* webpackChunkName: "school-affair" */ '@/views/school-affair/homework'),
			children: [
				{
					name: 'homework-work-list',
					path: 'work-list',
					fullPath: '/school-affair/homework/work-list',
					meta: {
						// title: '作业列表'
					},
					component: () =>
						import(/* webpackChunkName: "school-affair" */ '@/views/school-affair/homework/work-list')
				},
				{
					name: 'homework-publish',
					path: 'publish',
					fullPath: '/school-affair/homework/publish',
					meta: {
						// title: '发布作业'
					},
					component: () =>
						import(/* webpackChunkName: "school-affair" */ '@/views/school-affair/homework/publish')
				}
			]
		},
		{
			name: 'affair-healthy',
			path: 'healthy',
			meta: {
				title: '健康管理',
				icon: 'icon-home'
			},
			redirect: '/school-affair/healthy/summary',
			component: () =>
				import(/* webpackChunkName: "school-affair" */ '@/views/school-affair/healthy'),
			children: [
				{
					name: 'healthy-summary',
					path: 'summary',
					fullPath: '/school-affair/healthy/summary',
					meta: {
						// title: '学生健康信息汇总'
					},
					component: () =>
						import(/* webpackChunkName: "school-affair" */ '@/views/school-affair/healthy/summary')
				},
				{
					name: 'healthy-detail',
					path: 'detail',
					fullPath: '/school-affair/healthy/detail',
					meta: {
						// title: '学生健康信息明细'
					},
					component: () =>
						import(/* webpackChunkName: "school-affair" */ '@/views/school-affair/healthy/detail')
				},
				{
					name: 'healthy-record',
					path: 'record',
					fullPath: '/school-affair/healthy/record',
					meta: {
						// title: '用药提醒记录'
					},
					component: () =>
						import(/* webpackChunkName: "school-affair" */ '@/views/school-affair/healthy/record')
				},
				{
					name: 'healthy-menu',
					path: 'menu',
					fullPath: '/school-affair/healthy/menu',
					meta: {
						// title: '菜谱管理'
					},
					component: () =>
						import(/* webpackChunkName: "school-affair" */ '@/views/school-affair/healthy/menu')
				}
			]
		},
		{
			name: 'affair-devRecord',
			path: 'devRecord',
			meta: {
				title: '成长记录',
				icon: 'icon-home'
			},
			redirect: '/school-affair/devRecord/search',
			component: () =>
				import(/* webpackChunkName: "school-affair" */ '@/views/school-affair/devRecord'),
			children: [
				{
					name: 'devRecord-search',
					path: 'search',
					fullPath: '/school-affair/devRecord/search',
					meta: {
						// title: '校园社查看'
					},
					component: () =>
						import(/* webpackChunkName: "school-affair" */ '@/views/school-affair/devRecord/search')
				},
				{
					name: 'devRecord-audit-list',
					path: 'audit-list',
					fullPath: '/school-affair/devRecord/audit-list',
					meta: {
						// title: '校园社待审核列表'
					},
					component: () =>
						import(/* webpackChunkName: "school-affair" */ '@/views/school-affair/devRecord/audit-list')
				},
				{
					name: 'devRecord-audit-document',
					path: 'audit-document',
					fullPath: '/school-affair/devRecord/audit-document',
					meta: {
						// title: '校园社评论审核列表'
					},
					component: () =>
						import(/* webpackChunkName: "school-affair" */ '@/views/school-affair/devRecord/audit-document')
				},
				{
					name: 'devRecord-area-set',
					path: 'area-set',
					fullPath: '/school-affair/devRecord/area-set',
					meta: {
						// title: '显示范围设置'
					},
					component: () =>
						import(/* webpackChunkName: "school-affair" */ '@/views/school-affair/devRecord/area-set')
				},
				{
					name: 'devRecord-key-list',
					path: 'key-list',
					fullPath: '/school-affair/devRecord/key-list',
					meta: {
						// title: '关键字列表'
					},
					component: () =>
						import(/* webpackChunkName: "school-affair" */ '@/views/school-affair/devRecord/key-list')
				},
				{
					name: 'devRecord-video',
					path: 'video',
					fullPath: '/school-affair/devRecord/video',
					meta: {
						// title: '视频查看'
					},
					component: () =>
						import(/* webpackChunkName: "school-affair" */ '@/views/school-affair/devRecord/video')
				},
				{
					name: 'devRecord-self-audit-list',
					path: 'self-audit-list',
					fullPath: '/school-affair/devRecord/self-audit-list',
					meta: {
						// title: '学校自主审核列表'
					},
					component: () =>
						import(/* webpackChunkName: "school-affair" */ '@/views/school-affair/devRecord/self-audit-list')
				}
			]
		},
		{
			name: 'affair-mailbox',
			path: 'mailbox',
			fullPath: '/school-affair/mailbox',
			meta: {
				// title: '院长信箱',
				icon: 'icon-home'
			},
			component: () =>
				import(/* webpackChunkName: "school-affair" */ '@/views/school-affair/mailbox')
		},
		{
			name: 'affair-cloud-disk',
			path: 'cloud-disk',
			fullPath: '/school-affair/cloud-disk',
			meta: {
				// title: '教学云盘',
				icon: 'icon-home'
			},
			component: () =>
				import(/* webpackChunkName: "school-affair" */ '@/views/school-affair/cloud-disk')
		},
		{
			name: 'affair-questionnaire-survey',
			path: '/school-affair/questionnaire-survey',
			meta: {
				title: '问卷调查'
				// icon: 'icon-home'
			},
			component: () =>
				import(/* webpackChunkName: "school-affair" */ '@/views/school-affair/questionnaire-survey')
		},
		{
			name: 'questionnaire-details',
			path: '/school-affair/questionnaire-survey/details',
			meta: {
				// title: '问卷调查'
			},
			component: () =>
				import(/* webpackChunkName: "school-affair" */ '@/views/school-affair/questionnaire-survey/details')
		},
		// 校园亲情话机
		{
			name: 'affair-kinship-phone',
			path: 'kinship-phone',
			meta: {
				title: '亲情话机',
				icon: 'icon-home'
			},
			redirect: '/school-affair/kinship-phone/call-log',
			component: () =>
				import(/* webpackChunkName: "school-affair" */ '@/views/school-affair/kinship-phone'),
			children: [
				{
					name: 'kinship-phone-call-log',
					path: '/call-log',
					meta: {
						title: '通话记录'
					},
					component: () =>
						import(/* webpackChunkName: "school-affair" */ '@/views/school-affair/kinship-phone/call-log')
				},
				{
					name: 'kinship-phone-order-management',
					path: '/order-management',
					meta: {
						title: '订单管理'
					},
					component: () =>
						import(/* webpackChunkName: "school-affair" */ '@/views/school-affair/kinship-phone/order-management')
				},
				{
					name: 'kinship-phone-device-management',
					path: '/device-management',
					meta: {
						title: '设备管理'
					},
					component: () =>
						import(/* webpackChunkName: "school-affair" */ '@/views/school-affair/kinship-phone/device-management')
				},
				{
					name: 'kinship-phone-tariff-management',
					path: '/tariff-management',
					meta: {
						title: '资费管理'
					},
					component: () =>
						import(/* webpackChunkName: "school-affair" */ '@/views/school-affair/kinship-phone/tariff-management')
				},
				{
					name: 'kinship-phone-user-management',
					path: '/user-management',
					meta: {
						title: '用户管理'
					},
					component: () =>
						import(/* webpackChunkName: "school-affair" */ '@/views/school-affair/kinship-phone/user-management')
				},
				{
					name: 'kinship-account-management',
					path: '/kinship-account-management',
					meta: {
						title: '账户管理'
					},
					component: () =>
						import(/* webpackChunkName: "school-affair" */ '@/views/school-affair/kinship-phone/account-management')
				},
				{
					name: 'batch-open',
					path: '/user-management/batch-open',
					meta: {
						// title: '批量开通'
					},
					component: () =>
						import(/* webpackChunkName: "school-affair" */ '@/views/school-affair/kinship-phone/user-management/batch-open')
				}
			]
		},
		// 智能问答
		{
			name: 'question-answering',
			path: '/question-answering',
			meta: {
				title: '智能问答'
			},
			redirect: '/template-management',
			component: () =>
				import(/* webpackChunkName: "school-affair" */ '@/views/school-affair/question-answering'),
			children: [
				{
					name: 'template-management',
					path: '/template-management',
					meta: {
						title: '模板管理'
					},
					component: () =>
						import(/* webpackChunkName: "school-affair" */ '@/views/school-affair/question-answering/template-management')
				}
			]
		},
		{
			name: 'leave-management',
			path: 'leave-management',
			meta: {
				title: '请假管理',
				icon: 'icon-home'
			},
			redirect: '/school-affair/leave-management/list',
			component: () =>
				import(/* webpackChunkName: "school-affair" */ '@/views/school-affair/leave-management'),
			children: [
				{
					name: 'list',
					path: 'list',
					meta: {
						title: '请假列表'
					},
					fullPath: '/school-affair/leave-management/list',
					component: () =>
						import(/* webpackChunkName: "school-affair" */ '@/views/school-affair/leave-management/list')
				},
				{
					name: 'management',
					path: 'management',
					meta: {
						title: '添加管理'
					},
					fullPath: '/school-affair/leave-management/management',
					component: () =>
						import(/* webpackChunkName: "school-affair" */ '@/views/school-affair/leave-management/management')
				}
			]
		}
	]
};
